<template>
    <div>
        <h1 style="font-size: 24px; color: black;">收入量级日报</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub10" >
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button class="std" type="primary"  @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="dataList"
                      style="width: 100%"
                      border
                      :header-cell-style="{background:'#303133'}"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="项目" prop="appName" align="center"></el-table-column>
                <el-table-column label="日期" align="center">
                    <template slot-scope="scope" >
                        {{formatDate(scope.row.dt,"yyyy-MM-DD")}}
                    </template>
                </el-table-column>
                <el-table-column label="收入" align="center">
                    <el-table-column  label="总收入">
                        <template  slot-scope="scope">
                            {{scope.row.revenue==null?'0.00':scope.row.revenue.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="arpu">
                        <template  slot-scope="scope">
                            {{scope.row.arpu==null?'0.00':scope.row.arpu.toFixed(3)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="同比">
                        <template  slot-scope="scope">
                            {{scope.row.arpuSameRate==null?'0.00%':(scope.row.arpuSameRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.arpuCircleRate==null?'0.00%':(scope.row.arpuCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="ROI">
                        <template  slot-scope="scope">
                            {{scope.row.roi==null?'0.00%':(scope.row.roi*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="总ecpm" align="center">
                    <el-table-column  label="综合人均次数">
                        <template  slot-scope="scope">
                            {{scope.row.perTimes==null?'0.00':scope.row.perTimes.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="同比">
                        <template  slot-scope="scope">
                            {{scope.row.perTimesSameRate==null?'0.00%':(scope.row.perTimesSameRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.perTimesCircleRate==null?'0.00%':(scope.row.perTimesCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="综合ecpm">
                        <template  slot-scope="scope">
                            {{scope.row.ecpm==null?'0.00':scope.row.ecpm.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="同比">
                        <template  slot-scope="scope">
                            {{scope.row.ecpmSameRate==null?'0.00%':(scope.row.ecpmSameRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.ecpmCircleRate==null?'0.00%':(scope.row.ecpmCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="收入占比">
                        <template  slot-scope="scope">
                            {{scope.row.incomeRate==null?'0.00%':(scope.row.incomeRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="投放量级" align="center">
                    <el-table-column  label="成本">
                        <template  slot-scope="scope">
                            {{scope.row.cashCost==null?'0.00':scope.row.cashCost.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="有价新增">
                        <template  slot-scope="scope">
                            {{scope.row.register==null?'0.00':scope.row.register}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="涨降幅">
                        <template  slot-scope="scope">
                            {{scope.row.increase==null?'0.00%':(scope.row.increase*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="CPA单价">
                        <template  slot-scope="scope">
                            {{scope.row.cpaValue==null?'0.00':scope.row.cpaValue.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="占比">
                        <template  slot-scope="scope">
                            {{scope.row.proportion==null?'0.00%':(scope.row.proportion*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="友盟量级" align="center">
                    <el-table-column  label="新增">
                        <template  slot-scope="scope">
                            {{scope.row.newUser==null?'0.00':scope.row.newUser}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="活跃">
                        <template  slot-scope="scope">
                            {{scope.row.activeUser==null?'0.00':scope.row.activeUser}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="同比">
                        <template  slot-scope="scope">
                            {{scope.row.yoy==null?'0.00%':(scope.row.yoy*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="有价新增占比">
                        <template  slot-scope="scope">
                            {{scope.row.registerProportion==null?'0.00%':(scope.row.registerProportion*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[10,20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        searchMagnitudeAndIncome,
        downloadData
    } from "@/http/outApi";
    import utils from '@/utils';
    export default {
        name: "MagnitudeDataReport",
        data(){
            return{
                queryData:{
                    timeDate:['','']
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                dataList:[],
                loading:true,
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        // 把选择的第一个日期赋值给一个变量。
                        this.choiceDate = minDate.getTime();
                        // 如何你选择了两个日期了，就把那个变量置空
                        if (maxDate) this.choiceDate = ''
                    },
                    disabledDate: time => {
                        // 如何选择了一个日期
                        if (this.choiceDate) {
                            console.log(time.getTime(),66,this.choiceDate);
                            // 7天的时间戳
                            const one = 13 * 24 * 3600 * 1000;
                            // 当前日期 - one = 7天之前
                            const minTime = this.choiceDate - one;
                            // 当前日期 + one = 7天之后
                            const maxTime = this.choiceDate + one;
                            return (
                                time.getTime() < minTime ||
                                time.getTime() > maxTime
                            )
                        }else{
                            return false
                        }
                    }
                }
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            exportExcel(){
                let fileName = new Date().toLocaleString() + '收入量级日报.xlsx';
                downloadData(
                    '/report/exportMagnitudeAndIncome',
                    this.queryData,
                    fileName
                )
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.loading = true;
                searchMagnitudeAndIncome(this.queryData).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        this.dataList=resp.data.info.list;
                        this.page.totalElements =resp.data.info.total;
                    }
                });
            },
        },
        created () {
            this.queryData.timeDate = [utils.TodayUtil.getWeekAgo(),utils.TodayUtil.getToday()];
            this.query();
        }
    }
</script>
sh
<style scoped>

</style>